import React from 'react';
import { fromJS } from 'immutable';
import { updateContact } from 'flow/actions/contact-actions';
import ContactSettingRow from 'flow/components/contact-card/contact-fields/ContactSettingRow';
import Toggle from 'flow/components/ui-components/Toggle';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { ContactKey } from 'flow/types/EntityKeys';
import { ContactType } from 'flow/utils/extension-utils';

interface Props {
    contactKey: ContactKey;
    shared: boolean;
    className?: string;
}

const SharedContactListItem = ({ contactKey, shared, className }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const title = i18next.t('ContactCard.SharedContact.Switch.Title');

    const handleChange = (isShared: boolean) => {
        dispatch(
            updateContact(
                fromJS({
                    key: contactKey,
                    type: isShared
                        ? ContactType.shared.key
                        : ContactType.personal.key,
                }),
            ),
        );
    };

    return (
        <ContactSettingRow title={title} className={className}>
            <Toggle onChange={handleChange} value={shared} text={title} />
        </ContactSettingRow>
    );
};

export default SharedContactListItem;
